import { useUnit } from 'effector-react';
import $$api from 'models/api';
import { $global } from 'models/store-global';
import { useCallback, useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import styled from 'styled-components';

import PopUpWrapper from 'components/StyledTemplates/PopUpWrapper';

import { createTACStyles } from 'utils/tac-helper';

import useModal from 'hooks/useModal';
import useResources from 'hooks/useResources';

import { TRole } from 'types/Store';

const useUnmountedRef = () => {
    const [node, setNode] = useState<any>(null);
    const ref = useCallback((node: any) => node && setNode(node), []);
    return { ref, node };
};

const TermsAndConditionsModal = () => {
    const { state: role = 'user' } = useModal('TERMS_AND_CONDITIONS');
    const { t } = useResources();
    const htmlContent = useUnit($global.map((state) => state.tac?.[role as TRole]?.htmlContent || ''));
    // TODO: Need to find solution to mount something inside modal without using useUnmountedRef
    const { node: iframe, ref: iframeRef } = useUnmountedRef();

    useEffect(() => {
        $$api.termsAndConditions.loadRelevantFx(role);
    }, [role]);

    useEffect(() => {
        createTACStyles(htmlContent, iframe);
    }, [htmlContent, iframe]);

    return (
        <PopUpWrapper name="TERMS_AND_CONDITIONS" extra="height: 800px;">
            {!htmlContent && <Spinner animation="border" />}
            {htmlContent && (
                <Iframe
                    ref={iframeRef}
                    id="tac"
                    width="100%"
                    height="100%"
                    title={t('tac.title')}
                    data-hj-allow-iframe
                />
            )}
        </PopUpWrapper>
    );
};

const Iframe = styled.iframe<{ ref: any }>`
    height: calc(100vh - 170px);
    background: #ffffff;
    border: 1px solid rgba(211, 203, 189, 0.7);
    box-sizing: border-box;
    border-radius: 10px;

    * {
        html {
            padding: 80px 125px;
        }
    }
`;

export default TermsAndConditionsModal;
